export default "__VITE_ASSET__21112f3f__"